// @flow

import React from "react";

import Card from "@material-ui/core/Card";
import CardHeader from "@material-ui/core/CardHeader";
import CardContent from "@material-ui/core/CardContent";
import { withStyles } from "@material-ui/core/styles";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableRow from "@material-ui/core/TableRow";

const styles = theme => ({
  card: {
    marginBottom: theme.spacing.unit
  }
});

type Props = {
  adDuration: number,
  adVendor: string,
  adTag: string,
  classes: Object
};

const AdInfo = (props: Props) => {
  const { classes } = props;
  return (
    <Card className={classes.card}>
      <CardHeader title="Ad Info" />
      <CardContent>
        <Table>
          <TableBody>
            <TableRow>
              <TableCell>Ad Vendor</TableCell>
              <TableCell>{props.adVendor}</TableCell>
            </TableRow>
            <TableRow>
              <TableCell>Duration</TableCell>
              <TableCell>
                {props.adDuration > 0 ? props.adDuration : ""}
              </TableCell>
            </TableRow>
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};

export default withStyles(styles)(AdInfo);



// WEBPACK FOOTER //
// ./src/AdInfo/index.js